import React, { Suspense, Fragment, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import DashboardLayout from 'src/layouts/DashboardLayout'
import LoadingScreen from 'src/components/LoadingScreen'
import AuthGuard from 'src/components/AuthGuard'
import GuestGuard from 'src/components/GuestGuard'

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment
        const Layout = route.layout || Fragment
        const Component = route.component

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={(props) => (
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              </Guard>
            )}
          />
        )
      })}
    </Switch>
  </Suspense>
)

const routes = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/errors/NotFoundView')),
  },
  {
    exact: true,
    path: '/sign/:token',
    component: lazy(() => import('src/views/signature/SignaturePage')),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/LoginView')),
  },
  {
    exact: true,
    path: '/login-unprotected',
    component: lazy(() => import('src/views/auth/LoginView')),
  },
  {
    exact: true,
    guard: GuestGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/RegisterView')),
  },
  {
    exact: true,
    path: '/register-unprotected',
    component: lazy(() => import('src/views/auth/RegisterView')),
  },
  {
    path: '/app',
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/app/management/products',
        component: lazy(() => import('src/views/product/ProductListView')),
      },
      {
        exact: true,
        path: '/app/management/resources',
        component: lazy(() => import('src/views/resource')),
      },
      {
        exact: true,
        path: '/app/management/products/create',
        component: lazy(() =>
          import('src/views/product/ProductListView/PackageCreateView')
        ),
      },
      {
        exact: true,
        path: '/app/management/paymentmethod',
        component: lazy(() =>
          import('src/views/paymentMethod/PayMethodListView')
        ),
      },
      // {
      //   exact: true,
      //   path: '/app/management/paymentmethod/create',
      //   component: lazy(() =>
      //     import('src/views/paymentMethod/PaymentMethodAddEditForm')
      //   ),
      // },
      // {
      //   exact: true,
      //   path: '/app/account',
      //   component: lazy(() => import('src/views/errors/ComingSoonView')),
      // },
      {
        exact: true,
        path: '/app/role',
        component: lazy(() => import('src/views/role/RoleListView')),
      },
      {
        exact: true,
        path: '/app/system/menu',
        component: lazy(() => import('src/views/menu/MenuListView')),
      },
      {
        exact: true,
        path: '/app/system/sms-set',
        component: lazy(() => import('src/views/smsSet/SmsSetListView')),
      },
      {
        exact: true,
        path: '/app/system/email-template',
        component: lazy(() => import('src/views/emailTemplate/EmailTemplateView')),
      },
      {
        exact: true,
        path: '/app/system/sms-notify-phone',
        component: lazy(() => import('src/views/smsNotifyPhone/SmsNotifyPhone')),
      },
      {
        exact: true,
        path: '/app/system/dict',
        component: lazy(() => import('src/views/dict/DictListView')),
      },
      {
        exact: true,
        path: '/app/system/store',
        component: lazy(() => import('src/views/store/StoreListView')),
      },
      {
        exact: true,
        path: '/app/system/booking-config',
        component: lazy(() => import('src/views/bookingConfig/BookingConfigView')),
      },
      {
        exact: true,
        path: '/app/role/create',
        component: lazy(() => import('src/views/role/RoleCreateView')),
      },
      {
        exact: true,
        path: '/app/appointment',
        component: lazy(() => import('src/views/appointmentV2')),
      },
      {
        exact: true,
        path: '/app/inbox',
        component: lazy(() => import('src/views/inbox/InboxView')),
      },
      {
        exact: true,
        path: '/app/appointment-old',
        component: lazy(() => import('src/views/appointment')),
      },
      {
        exact: true,
        path: '/app/roster',
        component: lazy(() => import('src/views/roster')),
      },
      {
        exact: true,
        path: '/app/roster-v2',
        component: lazy(() => import('src/views/rosterV2')),
      },
      {
        exact: true,
        path: '/app/management/inventory',
        component: lazy(() => import('src/views/storage')),
      },

      // {
      //   exact: true,
      //   path: '/app/shift',
      //   component: lazy(() => import('src/views/shift/ShiftView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/members',
      //   component: lazy(() => import('src/views/member/MemberListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/members/create',
      //   component: lazy(() => import('src/views/member/MemberCreateView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/members/:memberId',
      //   component: lazy(() => import('src/views/member/MemberDetailsView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/members/:memberId/edit',
      //   component: lazy(() => import('src/views/member/MemberEditView'))
      // },
      {
        exact: true,
        path: '/app/management/customers',
        component: lazy(() => import('src/views/customer/CustomerListView')),
      },
      {
        exact: true,
        path: '/app/management/customer/create',
        component: lazy(() => import('src/views/customer/CustomerCreateView')),
      },
      {
        exact: true,
        path: '/app/management/customer/:customerId/service-hub',
        component: lazy(() => import('src/views/customer/CustomerServiceHub')),
      },
      {
        exact: true,
        path: '/app/management/customer/:customerId',
        component: lazy(() => import('src/views/customer/CustomerDetailsView')),
      },
      // {
      //   exact: true,
      //   path: '/app/management/invoices',
      //   component: lazy(() => import('src/views/invoice/InvoiceListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/invoices/:invoiceId',
      //   component: lazy(() => import('src/views/invoice/InvoiceDetailsView'))
      // },
      {
        exact: true,
        path: '/app/management/orders',
        component: lazy(() => import('src/views/order/OrderListView')),
      },
      {
        exact: true,
        path: '/app/management/order/create',
        component: lazy(() => import('src/views/order/OrderCreateView')),
      },
      {
        exact: true,
        path: '/app/management/orders/:orderId',
        component: lazy(() => import('src/views/order/OrderListDetailsView')),
      },
      {
        exact: true,
        path: '/app/management/orders/:orderId',
        component: lazy(() => import('src/views/order/OrderCreateView')),
      },
      {
        exact: true,
        path: '/app/management/updateorders/:orderId',
        component: lazy(() => import('src/views/order/OrderUpdateView')),
      },
      // {
      //   exact: true,
      //   path: '/app/management/payment/all',
      //   component: lazy(() => import('src/views/payment/PaymentListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/payment/create',
      //   component: lazy(() => import('src/views/payment/PaymentCreateView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/payment/pending',
      //   component: lazy(() => import('src/views/payment/PaymentPendingListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/payment/completed',
      //   component: lazy(() => import('src/views/payment/PaymentCompletedListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/products',
      //   component: lazy(() => import('src/views/product/ProductListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/products/create',
      //   component: lazy(() => import('src/views/product/ProductCreateView'))
      // },

      {
        exact: true,
        path: '/app/management/room',
        component: lazy(() => import('src/views/room'))
      },
      {
        exact: true,
        path: '/app/management/offer',
        component: lazy(() => import('src/views/offer')),
      },
      {
        exact: true,
        path: '/app/mobile-slip',
        component: lazy(() => import('src/views/mobile-slip/MobileSlipList')),
      },
      {
        exact: true,
        path: '/app/mobile-slip/:id',
        component: lazy(() => import('src/views/mobile-slip/MobileSlipDetail')),
      },
      {
        exact: true,
        path: '/app/management/employee',
        component: lazy(() => import('src/views/employee'))
      },
      {
        exact: true,
        path: '/app/finance/income',
        component: lazy(() => import('src/views/income/IncomeListView')),
      },
      {
        exact: true,
        path: '/app/finance/expense',
        component: lazy(() => import('src/views/expense/ExpenseListView')),
      },
      {
        exact: true,
        path: '/app/finance/summary',
        component: lazy(() => import('src/views/summary/SummaryListView')),
      },
      {
        exact: true,
        path: '/app/finance/salary',
        component: lazy(() => import('src/views/salary')),
      },
      {
        exact: true,
        path: '/app/finance/commission',
        component: lazy(() => import('src/views/commission')),
      },
      {
        exact: true,
        path: '/app/finance/graph',
        component: lazy(() => import('src/views/graph/GraphListView')),
      },
      {
        exact: true,
        path: '/app/accounts',
        component: lazy(() => import('src/views/account')),
      },
      {
        exact: true,
        path: '/app/management',
        component: () => <Redirect to='/app/appointment' />,
      },

      {
        component: () => <Redirect to='/404' />,
      },
    ],
  },
  {
    path: '*',
    routes: [
      {
        exact: true,
        guard: GuestGuard,
        path: '/',
        component: lazy(() => import('src/views/auth/LoginView')),
      },
      {
        component: () => <Redirect to='/404' />,
      },
    ],
  },
]

export default routes
